import type { ReactNode } from 'react';

export const symbol_battery_android_frame_bolt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-37.5 0-63.75-26.25T40-330v-300q0-37.5 26.25-63.75T130-720h539q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H130q-12.75 0-21.37 8.62Q100-642.75 100-630v300q0 12.75 8.63 21.37Q117.25-300 130-300h479q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H130Zm0-120v-240q0-12.75 8.63-21.38Q147.25-630 160-630h453q19.36 0 27.18 17T636-581L453-353q-8.34 10.73-20.85 16.87Q419.65-330 406-330H160q-12.75 0-21.37-8.63Q130-347.25 130-360Zm589 91q-4 5-9 2.5t-4-8.5l29-165H631q-9.75 0-13.87-8-4.13-8 1.87-16l182-227q4-5 9-2.5t4 8.5l-29 165h104q9.75 0 13.88 8 4.12 8-1.88 16L719-269Z"
		/>
	</svg>
);
